import _ from "lodash";

const getActiveTabConfig = ({ allOptions, activeTab }) => {
  return _.get(
    _.find(allOptions, option => option.key === activeTab),
    "config",
    {}
  );
};

const getSelectedEvidenceCount = ({ selectedCards }) => {
  return _.sum(_.map(selectedCards, cardType => _.size(cardType)));
};

const getAddButtonDisabilityStatus = ({
  initiallySelectedEvidence,
  selectedCards,
}) => {
  const initialFeedTypes = _.keys(initiallySelectedEvidence);

  const isInitialEvidencePresent = _.some(initialFeedTypes, feedType => {
    const feedEvidence = initiallySelectedEvidence[feedType];
    return !_.isEmpty(feedEvidence);
  });

  const selectedEvidenceFeedTypes = _.keys(selectedCards);

  const isEvidencePresent = _.some(selectedEvidenceFeedTypes, feedType => {
    const feedEvidence = selectedCards[feedType];
    return !_.isEmpty(feedEvidence);
  });

  return !(isEvidencePresent || isInitialEvidencePresent);
};

export const getAddButtonDisabilityStatusMemoized = _.memoize(
  getAddButtonDisabilityStatus,
  ({ initiallySelectedEvidence, selectedCards }) => {
    return JSON.stringify({ initiallySelectedEvidence, selectedCards });
  }
);

export const getActiveTabConfigMemoized = _.memoize(
  getActiveTabConfig,
  ({ allOptions, activeTab }) => {
    return JSON.stringify({ allOptions, activeTab });
  }
);

export const getSelectedEvidenceCountMemoized = _.memoize(
  getSelectedEvidenceCount,
  ({ selectedCards }) => {
    return JSON.stringify({ selectedCards });
  }
);
